import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProposalsService } from '../../../../services/api/proposals.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'proposals-scope-change',
  imports: [CommonModule],
  templateUrl: './proposals-scope-change.component.html',
  styleUrl: './proposals-scope-change.component.scss'
})
export class ProposalsScopeChangeComponent implements OnInit, OnChanges{
  @Input() proposal: any;
  
  scopeChanges: any[] = [];
  loading = false;
  
  constructor(
    private proposalsService: ProposalsService,
    private router: Router,
    private routeService: RouteService
  ) {}
  
  ngOnInit(): void {
    setTimeout(() => {
      if (this.proposal && this.proposal.proposalId) {
      this.loadScopeChanges();
    }
    }, 200);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['proposal']) {
      const currentValue = changes['proposal'].currentValue;
      if (currentValue && currentValue.proposalId) {
        if (!currentValue.hasOwnProperty('isShowButton')) {
          this.proposal.isShowButton = true;
        }
        this.loadScopeChanges();
      }
    }
  }
  
  loadScopeChanges(): void {
    this.loading = true;
    this.scopeChanges = []; 
    
    this.proposalsService.listProposalChildren(this.proposal.proposalId)
      .subscribe({
        next: (response: any) => {
         
          if (response && response.data && Array.isArray(response.data.proposals)) {
            this.scopeChanges = response.data.proposals;
          } else {
            console.warn('No valid scope changes data found in response:', response);
            this.scopeChanges = [];
          }
          this.loading = false;
        },
        error: (err: any) => {
          console.error('Error loading scope changes', err);
          this.scopeChanges = [];
          this.loading = false;
        }
      });
  }
  
  createNewScopeChange(): void {
    this.routeService.proposalsCreateInitFromProposal(this.proposal.proposalId);
  }

  goToProposalChildren(proposalId: number): void {
    const currentUrl = this.router.url;
    if (currentUrl.match(/\/proposals\/\d+$/)) {
      this.router.navigateByUrl('/app', { skipLocationChange: true }).then(() => {
        this.router.navigate([`/app/proposals/${proposalId}`]);
      });
    } else {
      this.routeService.proposalsDetail(proposalId);
    }
  } 
  
}
